// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6694) return "./css/theme.7415992656.bundle.css";
	// return url for filenames based on template
	return "./css/" + {"1039":"menu_desktop","1491":"menu_mobile"}[chunkId] + ".7415992656.chunkfile.css";
};